import { Card, Col, Layout, message, Row, Tag, Tooltip, Button, Progress, Alert } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined, MinusOutlined, ArrowRightOutlined, CloseOutlined } from '@ant-design/icons';


import axios from 'axios';
import moment from 'moment';
import React, { Component } from 'react';
import Carousel from './carousel';
import { SubscriptionContext } from '../../../contexts/SubscriptionContext';
const { Footer } = Layout;
class Homepage extends Component {
  static contextType = SubscriptionContext;
  constructor(props) {
    super(props);
    this.state = {
      hoverLatestUpdatesButton: false,
      loading: true,
      returnRate: '-',
      numberOfTotalReturns: '-',
      currency: '-',
      totalReturnValue: '-',
      changeInPercent: {},
      showTrialBar: false,
    };
  }

  componentDidMount() {
    this.initializeComponent();
  }

  initializeComponent = async () => {
    try {
      await Promise.all([
        this.loadReturnsData(),
        this.loadNPSScript(),
        this.checkIfPlanWithAppUsage(),
        this.setShowTrialBar()
      ]);
      this.setState({ loading: false });
    } catch (err) {
      this.setState({ loading: false });
      message.error('Error fetching data. Please try again.', 5);
    }
  };
  replaceSubscriptionToAllowCharges = async () => {
    const response =  await axios.post('/api/integrations/billing/replaceSubscriptionToAllowCharges');
    if (response.data.status === 'success') {
      window.location.href = response.data.redirectUrl;
    }
  };
  checkIfPlanWithAppUsage = async () => {
    const response = await axios.get('/api/integrations/billing/checkIfSubscriptionAllowCharges');
    this.setState({ showReplacePlanModal: !response.data.subscriptionAllowCharges });
  };
  setShowTrialBar = async () => {
    let inTrial = this.context.inTrial;
    if (inTrial === undefined) {
      try {
        // Wait for context to be available or fetch it directly
        const contextResponse = await axios.get('/api/contexts');
        inTrial = contextResponse.data.inTrial;
      } catch (error) {
        console.error('Error fetching context:', error);
      }
    }
    const dismissedInSession = window.sessionStorage.getItem('trialBarDismissedInSession');
    if (inTrial && !dismissedInSession) {
      this.setState({ showTrialBar: true });
    }
  };

  async loadReturnsData() {
    const getDateRange = (daysAgo) => ({
      startDate: moment().subtract(daysAgo + 30, 'days'),
      endDate: moment().subtract(daysAgo, 'days'),
    });

    const fetchAnalytics = async ({ startDate, endDate }) => {
      try {
        const response = await axios.post('/api/analytics', {
          startDate,
          endDate,
          adjustForOrderDate: false,
          includeOpenOrders: true,
        });
        if (!response?.data) return null;
        return response?.data;
      } catch (error) {
        return message.error('Error fetching analytics data from server.', 4);
      }
    };

    try {
      const currentPeriod = getDateRange(0);
      const previousPeriod = getDateRange(30);

      const [currentData, previousData] = await Promise.all([
        fetchAnalytics(currentPeriod),
        fetchAnalytics(previousPeriod),
      ]);

      //fix for null data
      if (currentData === null || previousData === null) {
        return;
      }

      const dataTypes = [
        'returnRate',
        'numberOfTotalReturns',
        'totalReturnValue',
      ];

      const changeInPercent = dataTypes.reduce((returnData, dataType) => {
        const currentValue = parseFloat(currentData[dataType]);
        const previousValue = parseFloat(previousData[dataType]);

        returnData[dataType] = previousValue !== 0 ? (dataType === 'returnRate') ? (currentValue - previousValue) : (((currentValue - previousValue) / previousValue) * 100).toFixed(2) : parseFloat(0).toFixed(2);
        return returnData;
      }, {});

      this.setState({
        returnRate: currentData.returnRate,
        numberOfTotalReturns: currentData.numberOfTotalReturns,
        currency: currentData.currency,
        totalReturnValue: currentData.totalReturnValue,
        changeInPercent,
      });
    } catch (err) {
      message.error('Error fetching analytics data.', 4);
    }
  }

  displayChangePercentTag = (changeInPercent) => {
    changeInPercent = Math.round(parseFloat(changeInPercent) * 100) / 100;
    if (changeInPercent > 0) {
      return (
        <Tag color="magenta">
          <div className="flex-row flex-row--noMargin flex-middle-xxs u-columnGap--xs">
            <ArrowUpOutlined />
            <div>{changeInPercent}%</div>
          </div>
        </Tag>
      );
    } else if (changeInPercent < 0) {
      return (
        <Tag color="cyan">
          <div className="flex-row flex-row--noMargin flex-middle-xxs u-columnGap--xs">
            <ArrowDownOutlined />
            <div>{changeInPercent}%</div>
          </div>
        </Tag>
      );
    } else if (changeInPercent === 0) {
      return (
        <Tag className="ant-tag-gray">
          <div className="flex-row flex-row--noMargin flex-middle-xxs u-columnGap--xs">
            <MinusOutlined />
            <div>{changeInPercent}%</div>
          </div>
        </Tag>
      );
    }
  };

  loadNPSScript = async () => {
    try {
      this.injectCustomStyles();
      const script = document.createElement('script');
      script.src = 'https://widget.reviews.io/modern-widgets/survey.js';
      script.async = true;
      script.onerror = () => {
        message.error(
          'Error loading the survey widget script. Please try again.',
          5
        );
      };

      document.body.appendChild(script);
    } catch (err) {
      message.error('Error loading widget. Please try again.', 5);
    }
  };

  injectCustomStyles = () => {
    const style = document.createElement('style');
    style.innerHTML = `
      .SurveyWidget-prefix .SurveyWidget {
        --panel-border-width: 0px !important;
        --panel-padding: 0px !important;
        --base-font-size: 18px !important;
        --primary-button-bg-color: #67C2C2 !important;
        --primary-button-border-color: #67C2C2 !important;
        --common-button-border-radius: 6px !important;
        --common-button-vertical-padding: 8px !important;
        --common-button-horizontal-padding: 20px !important;
      }
      .SurveyWidget-prefix .SurveyWidget--contentCenter .SurveyWidget__question__heading {
        text-align: left !important;
      }
      .SurveyWidget-prefix .SurveyWidget--inline .SurveyPanel {
        z-index: auto !important;
      }
      .SurveyWidget-prefix .SurveyWidget:not(.R-XS) .SurveyPanel .SurveyPanel__content .R-ContentCard .R-Button {
        display: block !important;
        width: fit-content !important;
        margin-right: 0px !important;
      }
    `;
    document.head.appendChild(style);
  };
  closeTrialBar = () => {
    window.sessionStorage.setItem('trialBarDismissedInSession', 'true');
    this.setState({ showTrialBar: false });
  };

  renderTrialBar = () => {
    const { inTrial, trialDaysLeft } = this.context;
    if (!inTrial || trialDaysLeft <= 0) return null;

    const barColor = trialDaysLeft > 5 ? '#129797' : '#EC644B';
    return (
      <Footer
        style={{
          position: "fixed",
          bottom: 0,
          left: "280px",
          right: 0,
          background: barColor,
          color: "#fff",
          padding: "10px 20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          boxSizing: "border-box",
        }}
      >
        {trialDaysLeft > 5
          ? <div>
            <strong>Enjoy full access during your free trial.</strong>
            <div style={{ fontSize: "12px" }}>Explore the platform without limits & find the plan that fits your store best.</div>
          </div>
          : <div >
            <strong>Make sure your return process continues without interruption.</strong>
            <div style={{ fontSize: "12px" }}>Choose a subscription plan to stay active - or reach out via live chat for help.</div>
          </div>
        }

        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "10px",
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          <Tag
            style={{
              display: "flex",
              alignItems: "center",
              padding: "5px 12px",
              backgroundColor: "rgba(255, 255, 255, 0.3)",
              backdropFilter: "blur(8px)",
              WebkitBackdropFilter: "blur(8px)",
              border: "1px solid rgba(255, 255, 255, 0.3)",
              color: "#fff",
              borderRadius: "8px",
              border: "none",
            }}
          >
            <Progress
              type="circle"
              percent={100}
              format={() => trialDaysLeft}
              strokeColor="#fff"
              size={40}
              className="custom-progress"
            />

            <style>
              {`
                .custom-progress .ant-progress-inner {
                  width: 30px !important;
                  height: 30px !important;
                  font-size: 12px !important;
                  text-color: #fff !important;
                }
                .custom-progress .ant-progress-text {
                  color: #fff !important;
                }
              `}
            </style>
            <span style={{ marginLeft: "8px", fontSize: "14px", color: "#fff" }}>Days left in the trial</span>
          </Tag>

          <Button type="primary" shape="round" style={{ background: "#fff", color: barColor, border: "none", marginRight: '20px' }} onClick={() => window.location.href = '/dashboard/account/profile'}>
            Choose a Subscription Plan
            <ArrowRightOutlined style={{ fontSize: "20px", fontWeight: "bold", strokeWidth: 4 }} />
          </Button>

          <Button
            type="default"
            shape="circle"
            size="small"
            style={{
              color: barColor,
              backgroundColor: "rgba(255, 255, 255, 0.6)",
              border: "none",
              width: "24px",
              height: "24px",
              fontSize: "12px",
            }}
            onClick={this.closeTrialBar}
          >
            <CloseOutlined style={{}} />
          </Button>
        </div>

        {/* Responsive Adjustments */}
        <style>
          {`
            @media (max-width: 767px) {
              .ant-layout-footer {
                left: 0 !important; /* Ignore sidebar */
                padding: 10px;
                flex-direction: column;
                align-items: center;
                text-align: center;
              }
            }

            @media (max-width: 600px) {
              .ant-layout-footer {
                flex-direction: column;
              }

              .ant-tag {
                flex-direction: column;
                text-align: center;
              }

              .ant-btn {
                width: 100%;
                text-align: center;
              }
            }
          `}
        </style>
      </Footer>
    );
  };
  render() {
    if (this.state.loading) {
      return (
        <div style={{ position: 'absolute', top: '50%', left: '50%' }}>
          <div className="GlobalLoader GlobalLoader--md"></div>
        </div>
      );
    }
    return (
      <div className="home-page">
        <h1 className="TextHeading TextHeading--sm u-marginBottom--md">Home</h1>
        <p></p>
        <Alert
          message=" "
          description={
            <span>
              Key return metrics from the <strong>past 30 days</strong> at a glance.
            </span>
          }
          type="info"
          showIcon
        />
        <div className="u-marginBottom--lg">
          <Row
            type="flex"
            gutter={10}
            style={{
              marginTop: '20px',
              textAlign: 'center',
              rowGap: '15px',
            }}
          >
            <Col
              xs={{ span: 24 }}
              sm={{ span: 12 }}
              md={{ span: 12 }}
              lg={{ span: 8 }}
            >
              <Tooltip
                placement="bottom"
                title="Return rate for the last 30 days: calculated as returns created divided by total orders placed."
              >
                <Card
                  title="Return Rate"
                  variant="outlined"
                  hoverable={false}
                  extra={<React.Fragment></React.Fragment>}
                >
                  <div style={{ flexDirection: 'column' }} className="flex-middle-xxs flex-row--noMargin flex-center-xxs">
                    <div style={{ textAlign: 'center' }} className="TextHeading TextHeading--sm u-marginBottom--none u-marginRight--sm">
                      {this.state.returnRate}
                    </div>
                    <div style={{ marginTop: '12px' }}>
                      {this.displayChangePercentTag(
                        this.state.changeInPercent.returnRate
                      )}
                    </div>
                  </div>
                </Card>
              </Tooltip>
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 12 }}
              md={{ span: 12 }}
              lg={{ span: 8 }}
            >
              <Tooltip
                placement="bottom"
                title="Total number of returns created over the last 30 days, reflecting all customer-initiated returns within this period."
              >
                <Card
                  title="Return Volume"
                  variant="outlined"
                  hoverable={false}
                  extra={<React.Fragment></React.Fragment>}
                >
                  <div style={{ flexDirection: 'column' }} className="flex-middle-xxs flex-row--noMargin flex-center-xxs">
                    <div style={{ textAlign: 'center' }} className="TextHeading TextHeading--sm u-marginBottom--none u-marginRight--sm">
                      {this.state.numberOfTotalReturns}
                    </div>
                    <div style={{ marginTop: '12px' }}>
                      {this.displayChangePercentTag(
                        this.state.changeInPercent.numberOfTotalReturns
                      )}
                    </div>
                  </div>
                </Card>
              </Tooltip>
            </Col>
            <Col
              xs={{ span: 24 }}
              sm={{ span: 12 }}
              md={{ span: 12 }}
              lg={{ span: 8 }}
            >
              <Tooltip
                placement="bottom"
                title="Total value of returns received over the last 30 days, representing the total amount refunded for all returned items within this period."
              >
                <Card
                  title="Return Value"
                  variant="outlined"
                  hoverable={false}
                  extra={<React.Fragment></React.Fragment>}
                >
                  <div style={{ flexDirection: 'column' }} className="flex-middle-xxs flex-row--noMargin flex-center-xxs">
                    <div style={{ textAlign: 'center' }} className="TextHeading text-center TextHeading--sm u-marginBottom--none u-marginRight--sm">
                      {this.state.totalReturnValue} {this.state.currency}
                    </div>
                    <div style={{ marginTop: '12px' }}>
                      {this.displayChangePercentTag(
                        this.state.changeInPercent.totalReturnValue
                      )}
                    </div>
                  </div>
                </Card>
              </Tooltip>
            </Col>
          </Row>
        </div>

        <Carousel />

        <div className="u-marginBottom--md"></div>

        {this.state.showTrialBar && this.renderTrialBar()}
      </div>

    );
  }
}

export default Homepage;
